import React from "react";
import { useNavigate } from "react-router-dom";
import { Button } from "@/components/ui/button";
import { CaretLeft } from "@phosphor-icons/react";

/**
 * Small ghost-style back button. Goes to `to` if provided, else uses
 * router back. Shows up on top of every secondary page (History, Records)
 * and the athlete WeekView when a coach is browsing.
 */
export default function BackButton({ to, label = "Back", className = "" }) {
  const navigate = useNavigate();
  const handle = () => {
    if (to) {
      navigate(to);
    } else if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate("/");
    }
  };
  return (
    <Button
      type="button"
      variant="ghost"
      onClick={handle}
      className={`rounded-xl text-ink-2 hover:text-ink hover:bg-muted2 -ml-2 px-2 ${className}`}
      data-testid="back-button"
    >
      <CaretLeft size={16} className="mr-1" />
      {label}
    </Button>
  );
}
